{
  "id": "instagram.com",
  "version": 1,
  "name": "Instagram",
  "author": "SR",
  "date": "2026-09-07",
  "url": "https://www.instagram.com",
  "strings": {
    "en": {
      "name": "Instagram",
      "help": [
        "https://www.instagram.com/download/request/",
        "(Log in)",
        "For data format select JSON",
        "Click Next",
        "Enter your Password and click 'Request Data'",
        "Wait for the Email and follow the instructions (about 10 minutes)"
      ]
    },
    "de": {
      "name": "Instagram",
      "help": [
        "https://www.instagram.com/download/request/",
        "(Melde Dich an)",
        "Unter Format der Informationen wähle JSON aus.",
        "Klicke auf Weiter",
        "Gebe Dein Passwort ein und klicke auf 'Download anfordern'.",
        "Du erhälst eine Email zum Herunterladen (etwa 10 Minuten)"
      ]
    }
  },
  "instructions": [],
  "fileStructure": [
    "your_instagram_activity/",
    "ads_information/",
    "preferences/",
    "personal_information/",
    "apps_and_websites_off_of_instagram/",
    "logged_information/",
    "connections/",
    "security_and_login_information/",
    "media/"
  ],
  "optionalFileStructure": [
    "messages/",
    "digital_wallets/",
    "guides/",
    "content/",
    "instagram_ads_and_businesses/",
    "media_settings/",
    "story_sticker_interactions/",
    "saved/",
    "followers_and_following/",
    "monetization/",
    "likes/",
    "ads_and_topics/",
    "comments/",
    "shopping/",
    "your_topics/",
    "information_about_you/",
    "recent_searches/",
    "login_and_account_creation/",
    "device_information/",
    "apps_and_websites/",
    "autofill_information/",
    "avatars_store/",
    "contacts/",
    "events/",
    "fundraisers/",
    "past_instagram_insights/",
    "reports/",
    "loyalty_accounts/"
  ]
}
